import { Component, OnInit, AfterViewInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { MONTH_LIST } from 'src/app/shared/data/month-list';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';

@Component({
  selector: 'app-performa-broker-manager-modal',
  templateUrl: './performa-broker-manager-modal.component.html',
  styleUrls: ['./performa-broker-manager-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PerformaBrokerManagerModalComponent extends DestructorComponent implements OnInit, AfterViewInit {
  countryList: any[] = [];
  monthList = MONTH_LIST;

  @ViewChild('modalFooter', { static: true }) modalFooter!: ElementRef;

  constructor(private _globalStateService: GlobalStateService) {
    super();
  }

  ngOnInit(): void {
    // Subscribe to countries from GlobalStateService
    this.subscriptions.push(
      this._globalStateService.GetCountries().subscribe(countries => {
        this.countryList = countries || [];
      })
    );
  }

  async ngAfterViewInit() {
    try {

      // Wait a tick to ensure DataTable renders
      setTimeout(() => {
        const pagination = document.querySelector('.dt-paging');
        if (pagination && this.modalFooter?.nativeElement) {
          this.modalFooter.nativeElement.appendChild(pagination);
        }
      }, 300);
    } catch (err) {
      console.error(err);
    }
  }
}